/**
 * OverviewSection.tsx
 * Overview section of the theme playground showing system introduction
 */

import React from 'react';
import { Card, CardHeader, CardBody } from '@enfomentis/ui';
import { Button } from '@enfomentis/ui';
import { Badge } from '@enfomentis/ui';
import { Chip } from '@enfomentis/ui';

export const OverviewSection: React.FC = () => {
  return (
    <div className="space-y-6">
      <Card shadow="lg" isHoverable>
        <CardHeader>
          <h3 className="text-xl font-semibold text-text-primary">Tailwind v4 Theme System</h3>
        </CardHeader>
        <CardBody>
          <div className="space-y-4">
            <p className="text-text-secondary">
              Our design system built on Tailwind v4 with CSS custom properties, providing seamless dark mode 
              support and consistent theming across all components.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Card>
                <CardBody>
                  <Badge color="primary" content="50+" className="mb-2">
                    <div className="w-8 h-8 bg-primary/10 rounded-lg"></div>
                  </Badge>
                  <h4 className="font-semibold text-text-primary">Color System</h4>
                  <p className="text-sm text-text-secondary">Semantic colors with dark mode variants</p>
                </CardBody>
              </Card>
              
              <Card>
                <CardBody>
                  <Chip color="success" className="mb-2">CSS Props</Chip>
                  <h4 className="font-semibold text-text-primary">Modern CSS</h4>
                  <p className="text-sm text-text-secondary">CSS custom properties for dynamic theming</p>
                </CardBody>
              </Card>
              
              <Card>
                <CardBody>
                  <Badge color="secondary" content="∞">
                    <div className="w-8 h-8 bg-secondary/10 rounded-lg"></div>
                  </Badge>
                  <h4 className="font-semibold text-text-primary">Components</h4>
                  <p className="text-sm text-text-secondary">All components inherit theme automatically</p>
                </CardBody>
              </Card>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Quick Theme Demo */}
      <Card>
        <CardHeader>
          <h3 className="text-lg font-semibold text-text-primary">Theme Toggle Demo</h3>
        </CardHeader>
        <CardBody>
          <p className="text-text-secondary mb-4">
            Switch themes using the toggle in the header to see all colors adapt instantly.
          </p>
          
          <div className="flex flex-wrap gap-3">
            <Button color="primary">Primary Button</Button>
            <Button color="secondary">Secondary Button</Button>
            <Button variant="bordered" color="primary">Outline Button</Button>
            <Badge color="success" content="12">
              <Button variant="ghost">With Badge</Button>
            </Badge>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};